import 'css-chunksrc/client/pages/planzoneMembersPage/resourcesMenu/styles.scss';export default {
  "resourcesMenu": "_resourcesMenu_puy4w_1",
  "section": "_section_puy4w_5",
  "title": "_title_puy4w_9",
  "activable": "_activable_puy4w_16",
  "activated": "_activated_puy4w_20"
};